/* Orbit PDP: Live-Aktualisierung bei Variantenwechsel, Mengenwahl -> Mengenfeld, Galerie-Extras */
import { StandardEvents } from '@shopify/events';

const bound = new WeakSet();

function sectionOf(el) {
  return el?.closest?.('.shopify-section') || null;
}

function syncQuantity(section) {
  if (!section) return;
  const bundle = section.querySelector('.o-pack');
  if (!bundle) return;
  const checked = bundle.querySelector('input:checked');
  const qty = Math.max(1, parseInt(checked?.value || '1', 10));
  section.querySelectorAll('input[name="quantity"]').forEach((input) => {
    if (!(input instanceof HTMLInputElement) || input.disabled) return;
    if (String(input.value) === String(qty)) return;
    input.value = String(qty);
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

function moveGalleryExtras(section) {
  if (!section) return;
  const media = section.querySelector('.product-information__media');
  const src = section.querySelector('.o-gx-src');
  if (!media || !src) return;
  media.classList.add('o-gx-host');
  media.querySelectorAll(':scope > .o-gx').forEach((n) => n.remove());
  src.querySelectorAll('.o-gx').forEach((n) => media.appendChild(n.cloneNode(true)));
}

function bindSection(section) {
  if (!section || bound.has(section)) return;
  bound.add(section);
  section.addEventListener(StandardEvents.productSelect, (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const p = event.promise;
    if (!p || typeof p.then !== 'function') return;
    p.then(({ detail }) => {
      const html = detail?.html;
      if (!html) return;
      section.querySelectorAll('[data-orbit-live]').forEach((el) => {
        const next = html.querySelector(`[data-orbit-live="${el.dataset.orbitLive}"]`);
        if (next) el.innerHTML = next.innerHTML;
      });
      requestAnimationFrame(() => {
        syncQuantity(section);
        if (!section.querySelector('.product-information__media > .o-gx')) moveGalleryExtras(section);
      });
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[orbit-pdp]', error);
    });
  });
}

function init() {
  document.querySelectorAll('.o-gx-src, .o-pack, [data-orbit-live]').forEach((el) => {
    const section = sectionOf(el);
    bindSection(section);
  });
  document.querySelectorAll('.o-gx-src').forEach((el) => moveGalleryExtras(sectionOf(el)));
  document.querySelectorAll('.o-pack').forEach((el) => syncQuantity(sectionOf(el)));
}

document.addEventListener('change', (event) => {
  const t = event.target;
  if (t instanceof HTMLInputElement && t.closest('.o-pack')) syncQuantity(sectionOf(t));
});

/* Vor jedem Absenden die gewaehlte Menge sicher uebernehmen */
document.addEventListener('submit', (event) => syncQuantity(sectionOf(event.target)), true);
document.addEventListener('click', (event) => {
  const t = event.target instanceof Element ? event.target.closest('.add-to-cart-button, .sticky-add-to-cart__button') : null;
  if (t) syncQuantity(sectionOf(t));
}, true);

document.addEventListener('shopify:section:load', init);
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
